export default __webpack_public_path__ + "static/media/payments.6b331a54.png";